var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      staticClass: "product-skeleton-tile",
      attrs: { width: 200, height: 400 }
    },
    [
      _c("rect", { attrs: { x: "0", y: "0", width: "100%", height: "70%" } }),
      _c("rect", { attrs: { x: "0", y: "75%", width: "80%", height: "5%" } }),
      _c("rect", { attrs: { x: "90%", y: "75%", width: "10%", height: "5%" } }),
      _c("rect", { attrs: { x: "0", y: "85%", width: "80%", height: "5%" } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }